import { render, staticRenderFns } from "./tertiary-nav.vue?vue&type=template&id=1311bc4c&scoped=true&lang=pug&"
import script from "./tertiary-nav.vue?vue&type=script&lang=coffee&"
export * from "./tertiary-nav.vue?vue&type=script&lang=coffee&"
import style0 from "./tertiary-nav.vue?vue&type=style&index=0&id=1311bc4c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1311bc4c",
  null
  
)

export default component.exports